var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-input-container",class:{ inline: _vm.inline, focused: _vm.focused, error: _vm.error, warning: _vm.warning }},[(_vm.ignoreLabel)?_vm._t("default"):_c('label',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }